<template>
  <el-select v-model="selectId" :clearable="true" filterable :placeholder="label" style="width: 100%">
    <el-option
      v-for="item in options"
      :key="item[vk]"
      :label="item[sk]"
      :value="item[vk] || 0">
    </el-option>
  </el-select>
</template>
<script>
  export default{
    name: 'dropdown',
    props: ['placeholder', 'data-list', 'data-url', 'value','value-key','show-key'],
    data(){
        if(this.dataList&&this.dataList[0]&&this.dataList[0]["id"]>0){
            this.options = this.dataList;
        }else{
            this.options = [];
            for(var i in this.dataList){
                var data = {};
                data.id = i-0;
                data.name = this.dataList[i];
                this.options.push(data);

            }
        }

      return {
        label: this.placeholder || '请选择',
        options: this.options || [],
        selectId: this.value,
        url: this.dataUrl,
        vk:this.valueKey || 'id',
        sk:this.showKey || 'name'

      }
    },
    mounted(){
      if (this.dataUrl) {
        this.get(this.dataUrl)
      }
    },

    methods: {
      get(url){
        this.$http$({method: 'get', url: url}, (data) => {
          this.options = data
        })
      }
    },
    watch: {

      selectId(val){
        this.$emit('input', val)
      },
      dataList(val){
          this.options = [];
          for(var i in val){
              var data = {};
              data.id = i;
              data.name = val[i];
              this.options .push(data);

          }
          // this.options = dataList;
        // this.options = val
      },
      dataUrl(val){
        this.get(val)
      },
      value(val){
        this.selectId = val
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dropdown.vue